import React, { useState } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormikProps } from 'formik';
import { FormValuesModel } from 'modules/Accounts/AccountActivity/AccountDetailSection/UpdateNicknameModalDialog';
import { updateNicknameValidation } from 'validations/accounting/accounts';

// components
import InnerForm from './InnerForm';
import {
  Form,
  Button,
  ModalDialog,
  RequiredPropsForFormModel,
  RequiredPropsForModalDialogModel,
} from '@ui';

interface IProps
  extends RequiredPropsForFormModel<FormValuesModel>,
    RequiredPropsForModalDialogModel {
  title?: string;
}

const UpdateNicknameModalDialog = ({
  title,
  isVisible,
  initialValues,
  onSubmit,
  closeCallback,
}: IProps) => {
  const { t } = useTranslation('common');
  const [isLoading, setLoading] = useState(false);

  const onRemove = async (form: FormikProps<FormValuesModel>) => {
    setLoading(true);
    await onSubmit({ accountNickname: '' }, form);
    setLoading(false);
    closeCallback();
  };

  return (
    <Form<FormValuesModel>
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={isVisible ? initialValues : null}
      validationSchema={updateNicknameValidation}
      renderForm={(form) => (
        <ModalDialog
          title={title}
          isVisible={isVisible}
          extendedFooterButtons={
            initialValues?.accountNickname && form.values.accountNickname ? (
              <Button
                size="large"
                danger
                loading={isLoading}
                onClick={() => onRemove(form)}
              >
                {t('remove')}
              </Button>
            ) : null
          }
          extendedFooterButtonsPosition="before"
          closeCallback={closeCallback}
        >
          <InnerForm />
        </ModalDialog>
      )}
    />
  );
};

export default UpdateNicknameModalDialog;
